export enum ButtonVariants {
  Standard = "standard",
  Outlined = "outlined",
  OutlinedInverted = "outlinedInverted",
  TextDecorated = "textDecorated",
  Text = "text",
  Danger = "danger",
  DangerOutlined = "dangerOutlined",
}

export type ButtonTypes = "button" | "submit" | "reset";
